import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux'

import { pathOr } from 'ramda'

import * as actions from './actions'

const plan = handleActions({
  [actions.setPlan]: (state, action) => action.payload,
}, false)

const coupon = handleActions({
  [actions.setCoupon]: (state, action) => action.payload,
}, false)

const activateDealStatus = handleActions({
  [combineActions(
    actions.activateDeal,
    actions.activateDealSuccess,
    actions.activateDealPending,
    actions.activateDealFailed,
  )]: (state, action) => action.type,
}, false)

const billingDealStatus = handleActions({
  [combineActions(
    actions.fetchDeal,
    actions.fetchDealSuccess,
    actions.fetchDealPending,
    actions.fetchDealFailed,
  )]: (state, action) => action.type,
}, false)

const billingDeal = handleActions({
  [actions.fetchDealSuccess]: (state, action) => action.payload
}, {})

const activateDealErrorMessage = handleActions({
  [actions.activateDealFailed]: (state, action) => pathOr(null, ['payload', 'response', 'message'], action)
}, null)

export default combineReducers({
  billingDealStatus,
  billingDeal,
  activateDealStatus,
  activateDealErrorMessage,
  plan,
  coupon,
})



// WEBPACK FOOTER //
// ./src/modules/billing/reducer.js